import React from 'react';
import PropTypes from 'prop-types';
import {
    Box,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
    Stack
} from '@mui/material';

export default function VariantList({ variants, onVariantChange }) {

    // Función que se dispara cuando se modifica un campo de una variante
    const handleFieldChange = (key, field, value) => {
        onVariantChange(key, field, value);
    };

    return (
        <Stack spacing={2}> {/* Stack para añadir espacio vertical entre cada tarjeta */}
            {variants.map((variant) => (
                <Card key={variant.key} variant="outlined">
                    <CardContent>
                        {/* Título de la variante (ej. "Talla: M / Color: Rojo") */}
                        <Typography variant="h6" component="div" sx={{ mb: 2 }}>
                            {variant.combination.map(attrValue => attrValue.value).join(' / ')}
                        </Typography>

                        {/* Campos editables dentro de una cuadrícula para que sea responsive */}
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Precio"
                                    type="number"
                                    size="small"
                                    value={variant.price}
                                    onChange={(e) => handleFieldChange(variant.key, 'price', e.target.value)}
                                    // --- LÍNEAS AÑADIDAS ---
                                    error={variant.errorPrice} // Usaremos una nueva prop para el error
                                    helperText={variant.errorPrice ? 'El precio es requerido' : ''}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Cantidad"
                                    type="number"
                                    size="small"
                                    value={variant.quantity}
                                    onChange={(e) => handleFieldChange(variant.key, 'quantity', e.target.value)}
                                    error={variant.errorQuantity} // Usaremos una nueva prop para el error
                                    helperText={variant.errorQuantity ? 'La cantidad es requerida' : ''}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="SKU (Opcional)"
                                    size="small"
                                    value={variant.sku}
                                    onChange={(e) => handleFieldChange(variant.key, 'sku', e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            ))}
        </Stack>
    );
}

// Los propTypes se mantienen, solo verificamos que los datos lleguen correctamente
VariantList.propTypes = {
    variants: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        price: PropTypes.any,
        quantity: PropTypes.any,
        sku: PropTypes.any,
        combination: PropTypes.array.isRequired,
        errorPrice: PropTypes.bool,
    })).isRequired,
    onVariantChange: PropTypes.func.isRequired,
};